<div class="container">
  <!-- Time setter: range sliders that snap (min 0–5 per minute, sec every 5) -->
  <div *ngIf="!stopWatchService.isActive() && !stopWatchService.isPaused() && !isFinished" class="time-setter">
    <div class="time-display">{{ getSecondsAsDigitalClock(timeInSeconds) }}</div>
    <div class="time-sliders">
      <div class="slider-row">
        <label>Min</label>
        <ion-range [min]="0" [max]="10" [step]="1" [(ngModel)]="selectedMinutes" (ionChange)="syncTimeFromSliders()" pin="true"></ion-range>
        <span class="slider-value">{{ selectedMinutes }}</span>
      </div>
      <div class="slider-row">
        <label>Sec</label>
        <ion-range [min]="0" [max]="55" [step]="5" [(ngModel)]="selectedSeconds" (ionChange)="syncTimeFromSliders()" pin="true"></ion-range>
        <span class="slider-value">{{ selectedSeconds }}</span>
      </div>
    </div>
  </div>
  <div *ngIf="stopWatchService.isActive() || stopWatchService.isPaused() || isFinished" class="watch">
    <ion-button fill="clear" color="white" class="minimize" (click)="minimize()">
      <ion-icon name="close-outline"></ion-icon>
    </ion-button>
    <div class="radial-progress" data-progress="0">
      <div class="circle">
        <div class="mask full" [style.transform]="stopWatchService.transform">
          <div class="fill" [style.transform]="stopWatchService.transform"></div>
        </div>
        <div class="mask half">
          <div class="fill" [style.transform]="stopWatchService.transform"></div>
          <div class="fill fix" [style.transform]="stopWatchService.fixTransform"></div>
        </div>
        <div class="shadow"></div>
      </div>
      <div class="inset">
        <div class="percentage">{{getDisplayTime()}}</div>
      </div>
    </div>
  </div>
  <div class="btns">
    <ion-button color="danger" (click)="cancel()" class="cancel">
      {{'general.cancel' | translate}}
    </ion-button>
    <ion-button color="success" *ngIf="(!stopWatchService.isActive() && !stopWatchService.isPaused()) || isFinished" (click)="start()" class="start">
      {{ isFinished ? 'Restart' : 'Start' }}
    </ion-button>
    <ion-button color="warning" *ngIf="stopWatchService.isActive() && !isFinished" (click)="stopWatchService.pauseTimer()" class="start">
      {{'general.pause' | translate}}
    </ion-button>
    <ion-button color="success" *ngIf="stopWatchService.isPaused() && !isFinished" (click)="stopWatchService.resumeTimer()" class="start">
      {{'general.resume' | translate}}
    </ion-button>
  </div>
</div>